export function aggregateOffers(rows) {
  return _.flatten(rows.map(rowObject => Object.values(rowObject.offer).map(row => {
    const { currency, groupList, mmvsList, vinList } = row
    // let _mmvsList = []
    // let _vinList = []
    let _itemsMap = {}
    let _sectionId = row.sectionId

    if (groupList) {
      _sectionId = groupList.map(({ sectionId }) => sectionId).sort().join('_')
      groupList.forEach(group => {
        _itemsMap[group.churnScore] = []
        let _itemsList = _itemsMap[group.churnScore]
        if (group.items === null || group.items.length === 0) {
          _itemsList.push({
            itemDescription: 'Generic Offer',
            itemTypeDescription: 'Generic Offer',
            offerType: row.offerType,
            priceValue: row.priceValue,
            quantity: null,
            sectionId: group.sectionId,
            status: group.churnScore
          })
        } else {
          group.items.forEach(item => {
            _itemsList.push({
              ...item,
              sectionId: group.sectionId,
              status: group.churnScore
            })
          })
        }
      })
    }

    // if (mmvsList) {
    //   _mmvsList = mmvsList.map(mvs => {
    //     return Object.values(_itemsMap).flat().map(item => {
    //       const { itemDescription, itemTypeDescription, offerType, priceValue, quantity, sectionId, status } = item
    //       return {
    //         currency,
    //         itemDescription,
    //         itemTypeDescription,
    //         offerType,
    //         priceValue,
    //         quantity,
    //         status,
    //         sectionId,
    //         mvs
    //       }
    //     })
    //   })
    // }

    // if (vinList) {
    //   _vinList = vinList.map(vin => {
    //     return Object.values(_itemsMap).flat().map(item => {
    //       const { itemDescription, itemTypeDescription, offerType, priceValue, quantity, sectionId, status } = item
    //       return {
    //         currency,
    //         itemDescription,
    //         itemTypeDescription,
    //         offerType,
    //         priceValue,
    //         quantity,
    //         status,
    //         sectionId,
    //         vin
    //       }
    //     })
    //   })
    // }

    // _mmvsList = _.flatten(_mmvsList).sort((row1, row2) => row1.mvs.localeCompare(row2.mvs))
    // _vinList = _.flatten(_vinList).sort((row1, row2) => row1.vin.localeCompare(row2.vin))

    return {
      ...row,
      sectionId: _sectionId,
      itemsList: _.flatten(Object.values(_itemsMap)),
      mmvsList,
      vinList,
      contentPriority: '',
      tags: []
    }
  })))
}
